// src/components/PeoplePlan/TheBench/components/WorkflowTable/WorkflowTable.js
import React from "react";
import WorkflowTableHeader from "./WorkflowHeader";
import WorkflowTableRow from "./WorkflowTableRow";
import FilterableHeader from "../../../FilterableHeader";
import "./WorkflowTable.css";

const WorkflowTable = ({
  employees,
  allEmployees,
  onSort,
  sortColumn,
  sortOrder,
  selectedEmployees,
  onCheckboxChange,
  onEmployeeSelect,
  columnFilters,
  onColumnFilterChange
}) => {
  return (
    <div className="table-container">
      <div className="table-scroll-wrapper">
        <table>
          <thead>
            <tr>
              <FilterableHeader
                column="employee_name"
                displayName="Employee Name"
                data={allEmployees}
                selectedValues={columnFilters}
                onFilterChange={onColumnFilterChange}
                onSort={onSort}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
              />
              <FilterableHeader
                column="mum_name"
                displayName="MUM Name"
                data={allEmployees}
                selectedValues={columnFilters}
                onFilterChange={onColumnFilterChange}
                onSort={onSort}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
              />
              <WorkflowTableHeader
                column="workflow_name"
                displayName="Workflow Name"
                onSort={onSort}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
              />
              <WorkflowTableHeader
                column="status"
                displayName="Workflow Status"
                onSort={onSort}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
              />
              <FilterableHeader
                column="corp"
                displayName="Location"
                data={allEmployees}
                selectedValues={columnFilters}
                onFilterChange={onColumnFilterChange}
                onSort={onSort}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
              />
            </tr>
          </thead>
          <tbody>
            {employees.length > 0 ? (
              employees.map((employee) => (
                <WorkflowTableRow
                  key={employee.user_id}
                  employee={employee}
                  isSelected={selectedEmployees.includes(employee.user_id)}
                  onCheckboxChange={onCheckboxChange}
                  onEmployeeSelect={onEmployeeSelect}
                />
              ))
            ) : (
              <tr>
                <td colSpan="5" className="empty-message">
                  No employees found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WorkflowTable;